// S-EXEC v2 (B9) — download chips for the files a code-interpreter / executable-
// skill run produced. Renders the 'artifacts' rich element on a chat message.
// Logic lives in artifactChip.js (100%-tested); this is a thin presentational shell.
// Download goes through skillsApi.downloadArtifact (JWT + blob), never a naked <a>.
import { useState } from "react";
import { COLORS } from "../../theme/colors";
import { skillsApi } from "../../api/client";
import { artifactIcon, artifactMeta, artifactColor } from "./artifactChip";

const BORDER = COLORS.border || "#e2e5eb";
const DIM = COLORS.textDim || "#9090a8";
const ACCENT = COLORS.accent || "#4F46E5";

function Chip({ art }) {
  const [busy, setBusy] = useState(false);
  const ic = artifactIcon(art.name, art.mime);
  const onGet = async () => {
    if (busy || !art.url) return;
    setBusy(true);
    try {
      await skillsApi.downloadArtifact(art.url, art.name);
    } finally {
      setBusy(false);
    }
  };
  return (
    <div style={{
      display: "flex", alignItems: "center", gap: 12, padding: "11px 13px",
      borderRadius: 14, background: COLORS.surface, border: `1px solid ${BORDER}`,
      minWidth: 236, maxWidth: "100%",
    }}>
      <span style={{
        width: 38, height: 38, borderRadius: 11, display: "grid", placeItems: "center",
        font: "700 12px/1 inherit", color: "#fff", flex: "0 0 auto",
        background: artifactColor(ic.cls),
      }}>{ic.label}</span>
      <span style={{ minWidth: 0, flex: 1 }}>
        <span style={{ display: "block", fontSize: 13, fontWeight: 650, color: COLORS.text,
          whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{art.name}</span>
        <span style={{ display: "block", fontSize: 11, color: DIM, marginTop: 1 }}>{artifactMeta(art)}</span>
      </span>
      <button type="button" onClick={onGet} disabled={busy}
        style={{
          font: "inherit", fontSize: 12, fontWeight: 700, color: "#fff", background: ACCENT,
          border: "none", borderRadius: 999, padding: "7px 14px",
          cursor: busy ? "default" : "pointer", whiteSpace: "nowrap", opacity: busy ? 0.6 : 1,
        }}>{busy ? "…" : "Download"}</button>
    </div>
  );
}

export default function ArtifactChips({ artifacts }) {
  const list = Array.isArray(artifacts) ? artifacts : [];
  if (!list.length) return null;
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 8 }}>
      {list.map((a, i) => <Chip key={a.id || a.name || i} art={a} />)}
    </div>
  );
}
